<template>
    <div>
        <div id="" class="container object-info objects container-mob" >
            <b-button variant="btn" @click="$router.go(-1)" v-b-tooltip.hover title="Назад" class="mr-2">
                <img width="40px" src="/static/images/icons/left-arrow.svg">
            </b-button>
            <div style="width: 93%; float: right;"><h2 class="section-head"  >{{$t('message.city_title')}} {{city['city_' + selectedLocale.suffix.toLowerCase() ]}}</h2>
            </div>
        </div>
        <div class="container">
            <div class="col-12 px-0 pb-3 filter-row">
                <hr/>
                <div class="form-row">
                    <div class="col">
                        <v-select multiple v-model="selected_category" :options="categories" :reduce="category => category.id"
                                  :label="'name_'+selectedLocale.suffix.toLowerCase()"
                        :placeholder="$t('message.select_category')"/>
                    </div>
                    <div class="col">
                        <v-select  v-model="selected_status" :options="status" :reduce="st => st.value"
                                  :label="'text_'+selectedLocale.suffix.toLowerCase()"
                                  :placeholder="$t('message.select_type')"/>
                    </div>
                    <div class="col">
                        <v-select multiple v-model="selected_regions" :options="regions" :reduce="st => st.id"
                                   :label="'region_'+selectedLocale.suffix.toLowerCase()"
                                  :placeholder="$t('message.select_district')"/>
                    </div>
                    <div class="col">
                        <div class="row">
                            <div class="col pr-0">
                                <datepicker  :language="ru" class="date_select" v-model="start_date" placeholder="start Date"></datepicker>
                            </div>
                            <div class="col pr-0">
                                <datepicker :language="ru" class="date_select" v-model="end_date" placeholder="end Date"></datepicker>
                            </div>
                        </div>
                    </div>
                    <div class="col-1 text-right">
                        <b-button variant="success" @click="SearchData" class="py-1">{{$t('message.search')}}</b-button>
                    </div>
                </div>
                <hr/>
               <!-- <b-col lg="12" class="text-right">
                    <b-button variant="success" :href="'/object/'">{{$t('message.search')}}</b-button>
                </b-col>-->
            </div>
            <div class="row filter-mob-row">
                <div class="col-12">
                    <div role="tablist">
                        <b-card no-body class="mb-1 topic-three">
                            <b-card-header header-tag="header" class="py-1" role="tab">
                                <button class="btn btn-light" href="#" v-b-toggle="'accordion-1'" style="float: right;"><i class="fas fa-bars"></i></button>
                            </b-card-header>
                            <b-collapse :id="'accordion-1'"  accordion="my-accordion" role="tabpanel">
                                <b-card-body>
                                    <b-card-text>
                                            <v-select multiple v-model="selected_category" :options="categories" :reduce="category => category.id"
                                                      :label="'name_'+selectedLocale.suffix.toLowerCase()"
                                                      :placeholder="$t('message.select_category')"/>
                                    </b-card-text>
                                    <b-card-text>
                                        <v-select  v-model="selected_status" :options="status" :reduce="st => st.value"
                                                   :label="'text_'+selectedLocale.suffix.toLowerCase()"
                                                   :placeholder="$t('message.select_type')"/>
                                    </b-card-text>
                                    <b-card-text>
                                        <v-select multiple v-model="selected_regions" :options="regions" :reduce="st => st.id"
                                                  :label="'region_'+selectedLocale.suffix.toLowerCase()"
                                                  :placeholder="$t('message.select_district')"/>
                                    </b-card-text>
                                    <b-card-text>
                                        <div class="row">
                                            <div class="col pr-0">
                                                <datepicker  :language="ru" class="date_select" v-model="start_date" placeholder="start Date"></datepicker>
                                            </div>
                                            <div class="col">
                                                <datepicker :language="ru" class="date_select" v-model="end_date" placeholder="end Date"></datepicker>
                                            </div>
                                        </div>
                                    </b-card-text>
                                    <b-card-text>
                                        <b-button variant="success" @click="SearchData" class="py-1">{{$t('message.search')}}</b-button>
                                    </b-card-text>
                                </b-card-body>
                            </b-collapse>
                        </b-card>
                    </div>
                </div>
            </div>
            <b-card-group columns>
                <b-card v-for="item in objects" v-bind:key="item.id" :img-src="'/static/uploads/'+item.photo" img-alt="Image"  img-height="168" img-top class="object_card">
                    <b-card-title style="min-height: 57px"><b>{{ func_substring(item['title_'+selectedLocale.suffix.toLowerCase()],30 ) }}</b></b-card-title>
                   <!-- <b-card-text>
                        <b v-if="item.number">Школа № {{item.number}} </b>
                        <b v-else><br/></b>
                    </b-card-text>-->
                    <hr/>
                    <div class="row">
                        <div class="col-6">
                            <small class="mb-0 p-b-10 font-weight-bold">Дата окончания</small>
                            <br/><small class="mt-0 p-t-10">{{formatDate(item.expDate)}}</small>
                        </div>
                        <div class="col-6">
                            <small class="mb-0 p-b-10 font-weight-bold">Район</small><br/>
                            <small class="mt-0 p-t-10">{{item['region_'+selectedLocale.suffix.toLowerCase()]}}</small>
                        </div>
                    </div>
                    <template v-slot:footer>
                        <b-col lg="12" class="text-center">
                            <router-link :to="'/object/'+item.school_id">
                                <b-button variant="primary" >{{$t('message.more_info')}}</b-button>
                            </router-link>
                        </b-col>
                    </template>
                </b-card>
            </b-card-group>
            <div class=" py-3">
                <!--<b-pagination
                        total-rows="3"
                        per-page="1"
                        aria-controls="my-table"
                        align="center"
                ></b-pagination>-->
            </div>
            <div v-if="objects.length === 0" class="text-center">
                <img src="/static/images/nodatafound.png" width="100%"/>
                       <h2 class="">{{$t('message.notfound')}}</h2>

            </div>
        </div>

    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import Datepicker from 'vuejs-datepicker';
    import { format, subDays} from 'date-fns';
    import {en, ru} from 'vuejs-datepicker/dist/locale'

    import {getCityID, getObjectsByCity, getCategories, getRegionCityId} from '../api/index'

    export default {
        name: 'object-gchp',
        components: {
            Datepicker
        },
        computed: {
            ...mapGetters(["selectedLocale"])
        },
        data() {
            return {
                selected_category: [],
                selected_status: null,
                selected_regions: [],
                selected: null,
                end_date: new Date(),
                start_date:  subDays(new Date(), 40),
                city: {},
                objects: [],
                categories: [],
                regions: [],
                status: [
                    {
                        value: 'active',
                        text_ru: 'Активные',
                        text_en: 'Active',
                        text_uz: 'Aktiv'
                    },
                    {
                        value: 'proposed',
                        text_ru: 'Предлагаемые',
                        text_uz: 'Taklif etiladi',
                        text_en: 'Offered',
                    }
                ],
                en: en,
                ru: ru
            }
        },
        mounted() {
            this.getData()
            this.SearchData()
        },
        methods: {
            getData() {
                getCategories().then(res => {
                    this.categories =  res.data
                })
                getCityID(this.$route.params.id).then(res => {
                    this.city = res.data[0]
                })
                getRegionCityId(this.$route.params.id).then(res => {
                    this.regions = res.data
                })
            },
            SearchData() {
                var query = {
                    regs: this.selected_regions.toString(),
                    cats: this.selected_category.toString(),
                    status: this.selected_status,
                    dateFrom: format(new Date(this.start_date), 'yyyy-MM-dd').toString(),
                   dateTo: format(new Date(this.end_date), 'yyyy-MM-dd').toString(),
                }
                getObjectsByCity( this.$route.params.id, query).then(res => {
                    this.objects = res.data
                })
            },
            formatDate(val) {
                var d = new Date(val)
                d.setTime( d.getTime() + d.getTimezoneOffset()*60*1000 );
                return format( d, 'yyyy-MM-dd HH:ii')
            },
            func_substring(val, count) {
                return  (val.length > count) ? val.substring(0,count)+'...' : val
            }
        }
    }
</script>

<style scoped>
.date_select >>> input {
    display: block;
    width: 100%;
    height: calc(1.4em + 0.7rem + 1px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    -webkit-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
}
    .object_card img {
        height: 168px;
    }
    @media (max-width: 1199px) {
        .filter-row {
            display: none
        }
    }
    @media (min-width: 1199px) {
        .filter-mob-row {
            display: none
        }
    }
    .filter-mob-row >>> .card-header {
        background-color: inherit;
        border-bottom: inherit !important;
    }
    .filter-mob-row >>> .card {
        border: inherit;
    }
    .container-mob {
        padding-top: 100px;
        display: flex;
    }
    @media (max-width: 768px) {
        .section-head {
            font-size: 1.5rem;
        }
    }
</style>
